import Routes from './Routes/Routes';
import HeroSection from './components/HeroSection/HeroSection';
import Navbar from './components/Navbar/Navbar';
import PackageSection from './components/PackageSection/PackageSection';

function App() {
  return (
    <>
      <div>
        <Routes />
      </div>
    </>
  );
}

export default App;
